import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthUtils } from 'src/services/Auth/Auth.utils';
import { appRoutes, RouteObject } from 'src/routes/routes.types';
import { usePreLoginAuthLocation } from 'src/routes/use-pre-login-auth-location';
import { useAuth } from 'src/services/Auth';

type ProtectedRouteProps = {
  route: RouteObject;
};

// TODO: This component should only be rendered once.
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ route }) => {
  const location = useLocation();
  const isLogged = !AuthUtils.isExpired();
  const { rememberLocation } = usePreLoginAuthLocation();
  const { refresh } = useAuth();

  useEffect(() => {
    // Invoke refresh token every hour
    const tokenRefreshInvertal = setInterval(() => refresh(), 60 * 60 * 1000);

    return () => {
      clearInterval(tokenRefreshInvertal);
    };
  }, []);

  if (!isLogged && route.restricted?.includes('guest')) {
    return <Navigate to={appRoutes.login} state={{ from: rememberLocation(location) }} replace />;
  }

  if (isLogged) {
    const userType = AuthUtils.getPayload()?.user_type;

    if (route.restricted?.includes(userType as any)) {
      return <Navigate to={appRoutes.profile} replace />;
    }
  }

  return (
    <route.layout>
      <Outlet />
    </route.layout>
  );
};
